<app-loading *ngIf="uploading"></app-loading>
<div
  class="drop-zone mb-4"
  (dragover)="onDragOver($event)"
  (drop)="onDrop($event)"
  (dragleave)="onDragLeave($event)"
  (click)="fileInput.click()"
>
  <input
    type="file"
    accept="image/*"
    #fileInput
    multiple
    (change)="inputFile($event)"
    style="display: none"
  />
  <img
    src="./assets/images/icon-uploadfile.png"
    alt=""
    width="75"
    height="60"
  />
  <div *ngIf="preview" class="container-preview">
    <img
      (click)="removeImage($event)"
      class="close-preview"
      src="./assets/images/icon-circle-fail.png"
      alt=""
    />
    <img class="preview" *ngIf="preview" [src]="preview" alt="Image Preview" />
  </div>
  <span>อัปโหลดรูปภาพที่นี้ <span>คลิกอัปโหลด</span></span>
  <span>PNG, JPG (max. x MB)</span>
</div>
